import React from 'react';
import { useNavigation } from '../contexts/NavigationContext.js';

function TermsOfService() {
    const { isMobile } = useNavigation();
    
    return (
        <div className="container mt-5">
            <div className="text-center mb-4">
                <img 
                    src="/MUSI.ico" 
                    alt="MUSI Logo" 
                    className="img-fluid" 
                    style={{ maxHeight: isMobile ? '90px' : '120px' }} 
                />
                <h2 className="mt-3">MUSI - Pogoji uporabe</h2>
            </div>
            
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="card shadow-sm">
                        <div className="card-body p-4">
                            <h3 className="card-title">POGOJI UPORABE</h3>
                            <p className="text-muted mb-4">Datum zadnje posodobitve: [12. April 2025]</p>

                            <section className="mb-4">
                                <h4>1. UVOD</h4>
                                <p>
                                    Dobrodošli v spletni aplikaciji za upravljanje glasbenih dogodkov (v nadaljevanju »Storitev« ali »Aplikacija«). 
                                    Aplikacija je osebni projekt posameznika in ni povezana z nobeno pravno osebo ali podjetjem.
                                </p>
                                <p>
                                    Z registracijo in uporabo Storitve potrjujete, da ste prebrali, razumeli in se strinjate s temi pogoji uporabe. 
                                    Prosimo, da jih skrbno preberete.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>2. OPIS STORITVE</h4>
                                <p>Aplikacija je namenjena glasbenikom in organizatorjem dogodkov ter omogoča:</p>
                                <ul>
                                    <li>Registracijo z e-poštnim naslovom,</li>
                                    <li>ustvarjanje in upravljanje podatkov o glasbenih dogodkih,</li>
                                    <li>povabilo drugih uporabnikov k sodelovanju,</li>
                                    <li>upravljanje seznamov skladb (setlist),</li>
                                    <li>osnovno koledarsko načrtovanje dogodkov.</li>
                                </ul>
                                <p>Storitev je trenutno na voljo brezplačno.</p>
                            </section>

                            <section className="mb-4">
                                <h4>3. REGISTRACIJA IN RAČUN</h4>
                                <p>Za uporabo Storitve je potrebna registracija in ustvarjanje uporabniškega računa. Ob tem se zavezujete, da boste:</p>
                                <ul>
                                    <li>posredovali točne, ažurne in popolne podatke,</li>
                                    <li>redno posodabljali svoje informacije,</li>
                                    <li>skrbno varovali geslo in prevzeli odgovornost za vse dejavnosti, povezane z vašim računom,</li>
                                    <li>nemudoma obvestili upravljavca o vsaki nepooblaščeni uporabi vašega računa.</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>4. OBVEZNOSTI UPORABNIKOV</h4>
                                <p>Z uporabo Storitve se zavezujete, da:</p>
                                <ul>
                                    <li>je ne boste uporabljali v nezakonite namene,</li>
                                    <li>ne boste objavljali vsebin, ki so nezakonite, žaljive, ponižujoče, obrekljive ali drugače neprimerne,</li>
                                    <li>ne boste nadlegovali, zlorabljali ali ogrožali drugih uporabnikov,</li>
                                    <li>ne boste poskušali nepooblaščeno dostopati do tujih računov,</li>
                                    <li>ne boste motili ali ogrožali delovanja Storitve,</li>
                                    <li>ne boste širili virusov ali druge zlonamerne kode,</li>
                                    <li>ne boste kopirali, spreminjali, prevajali ali ustvarjali izpeljank iz Storitve brez izrecnega dovoljenja.</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>5. INTELEKTUALNA LASTNINA</h4>
                                <p>
                                    Vse pravice intelektualne lastnine, povezane s Storitvijo – vključno z besedilom, grafiko, logotipi, 
                                    ikonami, slikami, zvoki, videi in programsko opremo – pripadajo upravljavcu ali njegovim dajalcem licence.
                                </p>
                                <p>
                                    Vsebina, ki jo v aplikacijo vnesejo uporabniki, ostane njihova last, vendar upravljavcu podeljujejo neizključno, 
                                    brezplačno, prenosljivo in podlicencirano globalno dovoljenje za uporabo, kopiranje, spreminjanje, objavljanje, 
                                    prikazovanje in distribuiranje te vsebine v okviru delovanja Storitve.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>6. PODATKI UPORABNIKA</h4>
                                <p>
                                    Ob uporabi Storitve lahko posredujete osebne podatke. Ti bodo obdelani v skladu z našo Politiko zasebnosti. 
                                    Z uporabo Storitve soglašate z načinom zbiranja in uporabe podatkov, kot je opredeljeno v omenjeni politiki.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>7. DOSTOPNOST STORITVE</h4>
                                <p>
                                    Storitev je v eksperimentalni fazi. Upravljavec si pridržuje pravico do spremembe, začasne ustavitve 
                                    ali popolne prekinitve delovanja Storitve (ali njenega dela) kadarkoli in brez predhodnega obvestila.
                                </p>
                                <p>
                                    Upravljavec ne prevzema odgovornosti do vas ali tretjih oseb za kakršnekoli spremembe, 
                                    začasne prekinitve ali prenehanje delovanja Storitve.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>8. OMEJITEV ODGOVORNOSTI</h4>
                                <p>
                                    Storitev je na voljo "takšna, kot je" in "kot je na voljo", brez kakršnih koli izrecnih ali implicitnih jamstev.
                                </p>
                                <p>
                                    V obsegu, ki ga dovoljuje zakon, upravljavec ne odgovarja za neposredno ali posredno škodo, 
                                    izgube ali druge posledice, ki izhajajo iz:
                                </p>
                                <ul>
                                    <li>uporabe ali nezmožnosti uporabe Storitve,</li>
                                    <li>napak ali pomanjkljivosti v vsebini,</li>
                                    <li>nepooblaščenega dostopa do vaših podatkov ali računov,</li>
                                    <li>začasne ali trajne ustavitve delovanja,</li>
                                    <li>škodljive programske opreme, prenesene prek Storitve.</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>9. PREKINITEV DOSTOPA</h4>
                                <p>
                                    Upravljavec lahko kadarkoli in brez predhodnega opozorila začasno ali trajno prekine vaš dostop 
                                    do Storitve, zlasti v primeru kršitve teh pogojev.
                                </p>
                                <p>
                                    Po prekinitvi morate takoj prenehati z uporabo Storitve. Določbe, ki po svoji naravi ostajajo 
                                    v veljavi tudi po prenehanju uporabe, ostanejo zavezujoče.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>10. SPREMEMBE POGOJEV</h4>
                                <p>
                                    Upravljavec si pridržuje pravico do spremembe teh pogojev kadarkoli. 
                                    Spremembe začnejo veljati takoj ob objavi v aplikaciji.
                                </p>
                                <p>Vaša nadaljnja uporaba pomeni, da se z novimi pogoji strinjate.</p>
                            </section>

                            <section className="mb-4">
                                <h4>11. PRISTOJNOST IN VELJAVNA ZAKONODAJA</h4>
                                <p>
                                    Ti pogoji se razlagajo v skladu s slovensko zakonodajo. 
                                    Vse morebitne spore bodo reševala pristojna slovenska sodišča.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>12. LOČLJIVOST</h4>
                                <p>
                                    Če se katera koli določba teh pogojev izkaže za neveljavno, nezakonito ali neizvršljivo, 
                                    to ne vpliva na veljavnost preostalih določb.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>13. CELOTEN DOGOVOR</h4>
                                <p>
                                    Ti pogoji skupaj s Politiko zasebnosti predstavljajo celoten dogovor med vami in upravljavcem 
                                    glede uporabe Storitve ter nadomeščajo vso predhodno komunikacijo in dogovore.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>14. KONTAKT</h4>
                                <p>
                                    Za vsa vprašanja ali pripombe v zvezi s temi pogoji uporabe nas kontaktirajte na: <br />
                                    <strong>E-pošta:</strong> [admin@musi.si]
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsOfService;